import { useCallback } from 'react';

/**
 * 요약 섹션의 탭 관리 로직을 담당하는 커스텀 훅
 * @param {number} activeTab - 현재 활성 탭
 * @param {function} setActiveTab - 탭 설정 함수
 * @param {object} scrollContainerRef - 스크롤 컨테이너 ref
 * @returns {object} - 탭 관리 관련 함수들
 */
export const useSummaryTabs = (activeTab, setActiveTab, scrollContainerRef) => {
  const handleTabChange = useCallback((event, newValue) => {
    setActiveTab(newValue);
    
    // 탭 변경 시 스크롤을 최상단으로 이동
    setTimeout(() => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }, 100); // 탭 전환 애니메이션 후 실행
  }, [setActiveTab, scrollContainerRef]);

  return {
    handleTabChange
  };
}; 